import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { AuthHttp } from 'angular2-jwt';
import { Http, Headers } from '@angular/http';
import { AuthService } from './auth/auth.service';
import { VendorDetailsViewModel } from '../models/VendorDetailsViewModel';
import { VendorDocument } from '../models/VendorDocument';
import { VendorInfo } from '../models/VendorInfo';
import { VendorPayment } from '../models/VendorPayment';
import { VendorPaymentDetails } from '../models/VendorPaymentDetails';
import { VendorRegister } from '../models/VendorRegister';
import { VendorStatement } from '../models/VendorStatement';
import { Observable } from 'rxjs/Observable';
import { VendorCase } from '../models/VendorCase';




@Injectable()
export class VendorService {
  myHeader: Headers;
  // public companyNameSource = new BehaviorSubject<string>('');
  //companyName = this.companyNameSource.asObservable();
  constructor(private http: Http,
    private authHttp: AuthHttp,
    public auth: AuthService) {
    this.myHeader = new Headers();
    this.myHeader.append('Content-Type', 'application/json');
    // To fix IE 11 cache API issue.
    this.myHeader.append('Cache-control', 'no-cache');
    this.myHeader.append('Cache-control', 'no-store');
    this.myHeader.append('Expires', '0');
    this.myHeader.append('Pragma', 'no-cache');
    console.log('flight hour Service Initialized...');
  }

  getVendorHomeInfo() {
    return this.authHttp.get(`/api/Vendor/home`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('GetVendorInfo has failed ' + res.status);
      } else {
        let data = res.json();
        //  this.companyNameSource.next(data.CompanyName);
        return data;
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getVendorInvoices(searchText: string, GPVID: string) {
    return this.authHttp.get(`/api/Vendor/InvoicesView?searchText=${searchText}&GPVID=${GPVID}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('InvoicesView has failed ' + res.status);
      } else {
        let data = res.json();
        //  this.companyNameSource.next(data.CompanyName);
        return data;
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getVendorPayments(searchText: string, GPVID: string) {
    return this.authHttp.get(`/api/Vendor/PaymentsView?searchText=${searchText}&GPVID=${GPVID}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('PaymentsView has failed ' + res.status);
      } else {
        let data = res.json();
        return data;
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }
  getVendorPaymentDetails(paymentNO: string, GPVID: string) {
    return this.authHttp.get(`/api/Vendor/PaymentDetails?PaymentNO=${paymentNO}&GPVID=${GPVID}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('PaymentsView has failed ' + res.status);
      } else {

       return  res.json();

      }
    });
  }

  getInvoicesView(searchText: string, GPVID: string) {
    return this.authHttp.get(`/api/Vendor/InvoicesView?searchText=${searchText}&GPVID=${GPVID}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error(' InvoicesView has failed ' + res.status);
      } else {
        let data = res.json();
        return data;
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }
  getInvoiceDetails(invNumber: string, GPVID: string) {
    return this.authHttp.get(`/api/Vendor/InvoiceDetails?InvoiceNO=${invNumber}&GPVID=${GPVID}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error(' InvoicesView has failed ' + res.status);
      } else {
        return res.json();

      }
    });
  }

  getVendorPurchaseOrders(searchText: string, GPVID: string) {
    return this.authHttp.get(`/api/Vendor/POView?searchText=${searchText}&GPVID=${GPVID}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('GetVendorInfo has failed ' + res.status);
      } else {
        let data = res.json();
        return data;
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getVendorContacts(GPVID: string) {
    return this.authHttp.get(`/api/Vendor/GetVendorContacts?psGPVID=${GPVID}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('getVendorContacts has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getCountryList() {
    return this.authHttp.get(`/api/Contact/CountryList`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Get Countries request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getStateList() {
    return this.authHttp.get(`/api/Contact/StateList`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('Get Countries request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getVendorContactByAddressCode(GPVID: string, addressCode: string) {
    return this.authHttp.get(`/api/Vendor/GetContactInfoByAddressCode?psGPVID=${GPVID}&psAddressCode=${addressCode}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('getVendorContactByAddressCode request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  updateVendorContact(contact: VendorInfo) {
    return this.authHttp.post(`/api/Vendor/UpdateContactInfoByAddressCode`, contact, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('updateVendorContact has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

  getPODetails(poNumber: string) {
    return this.authHttp.get(`/api/Vendor/PODetails?psPONumber=${poNumber}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('getPODetails request has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  submitStatement(vendorStmt: VendorStatement) {
    return this.authHttp.post(`/api/Vendor/InsertStatement`, vendorStmt, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('submitStatement has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  getOpenPOs(gpVID: string) {
    return this.authHttp.get(`/api/Vendor/GetOpenPOs?psGPVID=${gpVID}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('getOpenPOs request has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  submitInvoice(vendorDoc: VendorDocument) {
    return this.authHttp.post(`/api/Vendor/SubmitVendorInvoice`, vendorDoc, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('submitInvoice has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  checkInvoiceNumber(invoiceNumber: string, gpVID: string) {
    return this.authHttp.get(`/api/Vendor/CheckInvoiceNumber?psInvoiceNumber=${invoiceNumber}&psGPVID=${gpVID}`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('checkInvoiceNumber request has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  getVendorClientDetails(searchType: Number, searchText: string, maxAllowedSearches: Number, gpVID: string) {
    return this.authHttp.get(`/api/Vendor/GetVendorClientDetails?piSearchType=${searchType}&psSearchText=${searchText}&piMaxAllowedSearch=${maxAllowedSearches}&psGPVID=${gpVID}`
    , { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('getVendorClientDetails request has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  getVendorClientSearchTypes() {
    return this.authHttp.get(`/api/Vendor/GetVendorClientSearchTypes`, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('getVendorClientSearchTypes request has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  updateCoverageSearchPrivacyDate() {
    return this.authHttp.post(`/api/Vendor/UpdateCoverageSearchPrivacyDate`, null, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('updateCoverageSearchPrivacyDate has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }


  createVendorCase() {
    return this.authHttp.post(`/api/Vendor/CreateVendorCase`, null, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('CreateVendorCase has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  updateVendorBankInfo(vendorRequest: any) {
    return this.authHttp.post(`/api/Vendor/UpateVendorBankInfo`, vendorRequest, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('updateVendorBankInfo has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  updateVendorCompanyInfo(vendorRequest: any) {
    return this.authHttp.post(`/api/Vendor/UpateVendorCompanyInfo`, vendorRequest, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('updateVendorCompanyInfo has failed ' + res.status);
      } else {
        return res.json();
      }
    });
  }

  updateVendorRemitToInfo(vendorRequest: any) {
    return this.authHttp.post(`/api/Vendor/UpateVendorRemitToInfo`, vendorRequest, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('updateVendorRemitToInfo has failed ' + res.status);
      } else {
        return res.status;
      }
    });
  }

  updateVendorTaxForm(vendorRequest: any) {
    return this.authHttp.post(`/api/Vendor/UpateVendorTaxForm`, vendorRequest, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('updateVendorTaxForm has failed ' + res.status);

      } else {
        return res.json();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/vendor.service.ts